const IconVK = (props: { className?: string; onClick?: () => void; stroke?: string; width?: number; height?: number }) => {
    const { className = '', onClick = () => null, stroke = '#00abfb', width = 28, height = 28 } = props

    return (
        <svg
            onClick={onClick}
            className={'icon-btn ' + className}
            width={width}
            height={height}
            fill='none'
            stroke={stroke}
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='2'
            viewBox='0 0 24 24'
        >
            <path stroke='none' d='M0 0h24v24H0z' />
            <path d='M10 6h2v12c-4.5-1-8-6.5-9-12M20 6c-1 2-3 5-5 6h-3M20 18c-1-2-3-5-5-6' />
        </svg>
    )
}

export default IconVK
